module.exports = __webpack_public_path__ + "media/images/icons/outlined/heat-map-156cb9f8c9d492aeba985232f9813935.svg";